module.exports = __webpack_public_path__ + "media/images/sp/reports/mv_title_ribbon_side-8eeae27adbc44fdd6d383c92327d3637.png";